import {
  AccountResult,
  baseMethods,
  ContactResult,
  InboxListResult,
  NumberResult,
  ResultType,
  ResultTypesEnum,
  StringResult,
  TagListResult,
  TeammateListResult,
  TeammateResult,
  TopicListResult,
} from './internal';

export const conversationType: ResultType = {
  name: ResultTypesEnum.CONVERSATION,
  properties: {
    id: StringResult,
    subject: StringResult,
    assignee: TeammateResult,
    num_messages: NumberResult,
    inbox_owner: TeammateResult,
    contact: ContactResult,
    account: AccountResult,
    tags: TagListResult,
    topics: TopicListResult,
    inboxes: InboxListResult,
    participants: TeammateListResult,
  },
  methods: {
    ...baseMethods,
  },
};
